import axios from 'axios';
import apiConfig from '../../api.config';

export default function forceBookingReport({ hotelId, date }) {
  const {
    host,
    URIs: { forceBookingReport },
  } = apiConfig;

  const uri = `${host}${forceBookingReport}`;

  return axios
    .post(uri, JSON.stringify({ hotelId, date }), {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => {
      return res.data;
    });
}
